/* eslint-disable react-hooks/exhaustive-deps */
import { faCirclePlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FieldArray, FormikProps, getIn, useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";

import { IInterestIncomes } from "../../../../config/interfaces";
import FASvgIcon from "../../../FASvgIcon";
import PreventEditComponent from "../../../PreventEditComponent";
import PriceDisplay from "../../../PriceDisplay";
import { NumericInputField, TextInputField } from "../../../fields";

const OIInterestFromP2PForm: React.FC = () => {
  const { values } = useFormikContext<IInterestIncomes>();

  const [sum, setSum] = useState(0);
  const [inputTotal, setInputTotal] = useState<{ [key: string]: number }>({});
  const [currentTime, setCurrentTime] = useState<number>(new Date().getTime());

  useEffect(() => {
    let _sum = 0;
    let _totalInput: { [key: string]: number } = {};
    if (values?.P2PInvestments.length) {
      values?.P2PInvestments.forEach((item, index) => {
        _totalInput[index] = parseInt(item[1]) || 0;
        if (item.length && item[1]) {
          _sum += parseInt(item[1]) || 0;
        }
      });
      setInputTotal(() => _totalInput);
    }
    setSum(() => _sum);
  }, [currentTime]);

  const handleAmountInc = (amt: number, index: string) => {
    inputTotal[index] = amt;
    setInputTotal(() => inputTotal);
    const _sum = Object.values(inputTotal).reduce((a, b) => Number(a) + Number(b), 0);
    setSum(() => _sum);
  };

  return (
    <>
      <div className="section-title-wrap">
        <h5>
          Interest earned from P2P Investments
          <small>Popular Platforms: CredMint, 12% Club, LendBox, IndiaP2P</small>
        </h5>
      </div>
      <Card className="more-info-card shadow-none mb-5">
        <Card.Header>
          <Card.Title>P2P Investments</Card.Title>
        </Card.Header>
        <Card.Body>
          <section>
            <FieldArray name="P2PInvestments">
              {({ push, replace, remove, form }) => (
                <>
                  {values?.P2PInvestments && values?.P2PInvestments?.length > 0
                    ? values?.P2PInvestments.map((_, index) => (
                        <section className="mb-3 mb-sm-0" key={`salary-allowance-${index}`}>
                          <P2PInvestmentsForm
                            index={index}
                            form={form}
                            onRemove={(itemIdx: number) => {
                              if (values.P2PInvestments.length === 1) {
                                replace(itemIdx, ["", ""]);
                              } else {
                                remove(itemIdx);
                              }

                              setCurrentTime(new Date().getTime());
                            }}
                            handleAmountInc={handleAmountInc}
                          />
                        </section>
                      ))
                    : null}
                  <PreventEditComponent>
                    <Button variant="link" className="btn-add-link" onClick={() => push(["", ""])}>
                      <FASvgIcon icon={faCirclePlus} />
                      Add more
                    </Button>
                  </PreventEditComponent>
                </>
              )}
            </FieldArray>
          </section>
        </Card.Body>
        <Card.Footer>
          <p className="total-content">
            <span className="total-label">Total:</span>
            <span className="total-amount">
              <PriceDisplay price={sum} />
            </span>
          </p>
        </Card.Footer>
      </Card>
    </>
  );
};

export default OIInterestFromP2PForm;

type P2PInvestmentsProps = {
  index: number;
  form: FormikProps<IInterestIncomes>;
  onRemove: (itemIdx: number) => void;
  handleAmountInc: (amt: number, index: string) => void;
};

const P2PInvestmentsForm: React.FC<P2PInvestmentsProps> = (props: P2PInvestmentsProps) => {
  const { index, onRemove, form, handleAmountInc } = props;

  const { setFieldValue, handleBlur, values, touched, errors } = form;

  return (
    <>
      <Row className="align-items-center">
        <Col sm>
          <TextInputField
            name={`P2PInvestments.${index}[0]`}
            label="Name of Platform"
            value={values.P2PInvestments[index][0] || ""}
            onChange={(value) => setFieldValue(`P2PInvestments.${index}[0]`, value)}
            onBlur={(e) => {
              handleBlur(e);
              setFieldValue(`P2PInvestments.${index}[0]`, values.P2PInvestments[index][0].trim());
            }}
            isInvalid={
              Boolean(getIn(errors, `P2PInvestments.${index}[0]`)) &&
              getIn(touched, `P2PInvestments.${index}[0]`)
            }
            errorMsg={getIn(errors, `P2PInvestments.${index}[0]`)}
          />
        </Col>
        <Col sm>
          <NumericInputField
            showLeftIcon={true}
            placeholder=""
            name={`P2PInvestments.${index}[1]`}
            label="Amount"
            value={values.P2PInvestments[index][1]}
            onBlur={handleBlur(`P2PInvestments.${index}[1]`)}
            onChange={(value) => {
              setFieldValue(`P2PInvestments.${index}[1]`, value);
              setTimeout(() => {
                handleAmountInc(Number(value), String(index));
              }, 100);
            }}
            isInvalid={
              Boolean(getIn(errors, `P2PInvestments.${index}[1]`)) &&
              getIn(touched, `P2PInvestments.${index}[1]`)
            }
            errorMsg={getIn(errors, `P2PInvestments.${index}[1]`)}
          />
        </Col>
        <PreventEditComponent>
          <Col sm={"auto"} className="ps-0">
            <Button
              variant="transparent"
              className="text-greyDark icon-only d-none d-sm-flex"
              onClick={() => onRemove(index)}
            >
              <FASvgIcon icon={faTrash} />
            </Button>
            <Button
              variant="transparent"
              className="btn-delete-full d-sm-none"
              onClick={() => onRemove(index)}
            >
              <FASvgIcon icon={faTrash} />
              <span>Delete</span>
            </Button>
          </Col>
        </PreventEditComponent>
      </Row>
      {index !== values.P2PInvestments.length - 1 && <hr className="d-block d-sm-none my-4" />}
    </>
  );
};
